import {
    MANUTENCAO_USUARIOS_INIT,
    MANUTENCAO_USUARIOS_GESTAO_USUARIO,
    MANUTENCAO_USUARIOS_EXCLUIR_USUARIO,
    MANUTENCAO_REGIOES_INIT,
    MANUTENCAO_REGIOES_ADD_REGIAO_LOCALIDADE,
    MANUTENCAO_REGIOES_DEL_REGIAO_LOCALIDADE,
    MANUTENCAO_REGIOES_UPD_REGIAO_LOCALIDADE,
    MANUTENCAO_REGIOES_ADD_REGIAO,
    MANUTENCAO_VARIAVEIS_INIT,
    MANUTENCAO_VARIAVEIS_ADD_VARIAVEL,
    MANUTENCAO_VARIAVEIS_UPD_VARIAVEL,
    MANUTENCAO_VARIAVEIS_DEL_VARIAVEL,
    MANUTENCAO_VARIAVEIS_UPD_VALOR_VARIAVEL,
    MANUTENCAO_SET_DRAWER,
    MANUTENCAO_CARGO_INIT,
    MANUTENCAO_CARGO_ADD,
    MANUTENCAO_CARGO_UPD,
    MANUTENCAO_CARGO_DEL,
} from '../actions';


export default function manutencaoReducer(state = null, action){
    switch(action.type){
        
        case MANUTENCAO_USUARIOS_INIT: // Para inserção de USUARIOS
            return {
                ...state,
                'usuarios': action.data
            }
        case MANUTENCAO_REGIOES_INIT: // Para inserção dos dados relacionados as regioes
            return {
                ...state,
                'regioes': action.data
            }
        case MANUTENCAO_USUARIOS_GESTAO_USUARIO: // Para gestao dos USUARIOS
            return (()=>{
                const oldState = state.usuarios.slice();
                //
                const { data, id_usuario } = action.data;
                // Filtra para nao contar com o id_usuario enviado e insere o novo dado
                return {
                    ...state,
                    usuarios: oldState.filter(ele=> String(ele.id_usuario) !== String(id_usuario)).concat(data)
                }
            })();
        case MANUTENCAO_USUARIOS_EXCLUIR_USUARIO: // Para exclusao de um usuario
            return {
                ...state,
                usuarios: state.usuarios.filter(ele=> String(ele.id_usuario) !== String(action.data) )
            }
        case MANUTENCAO_REGIOES_ADD_REGIAO_LOCALIDADE: // Para inclusao de regiao/localidade
            return {
                ...state,
                'regioes': {
                    ...state.regioes,
                    'dados': state.regioes.dados.concat(action.data)
                }
            }
        case MANUTENCAO_REGIOES_DEL_REGIAO_LOCALIDADE: // Para remover a localidade/regiao
            return {
                ...state,
                'regioes': {
                    ...state.regioes,
                    'dados': state.regioes.dados.filter(ele=> String(ele.id_localidade) !== String(action.data))
                }
            }
        case MANUTENCAO_REGIOES_UPD_REGIAO_LOCALIDADE: // Para editar uma regiao ja inclusa
            return (()=>{
                const { dados } = state.regioes;
                // Filtra inicialmente retirando o que ja existe
                let filtro = dados.map(ele=>{
                    if(String(ele.id_localidade) === String(action.data.id_localidade) ){
                        return action.data;
                    }
                    return ele;
                })
                return {
                    ...state,
                    'regioes': {
                        ...state.regioes,
                        'dados': filtro,
                    }
                }
            })();
        case MANUTENCAO_REGIOES_ADD_REGIAO: // Usado para adicionar uma região na lista de regiões
            return {
                ...state,
                'regioes': {
                    ...state.regioes,
                    'regioes': state.regioes.regioes.concat(action.data),
                }
            }
        case MANUTENCAO_VARIAVEIS_INIT: // Usado para atribuir as variaveis recuperadas
            return {
                ...state,
                'variaveis': action.data
            }
        case MANUTENCAO_SET_DRAWER: // Usado para definir o tipo de drawer/dialog a ser exibido
            return {
                ...state,
                drawer: action.data
            }
        case MANUTENCAO_VARIAVEIS_ADD_VARIAVEL: // Usado para adicionar uma variavel ao objeto de variaveis
            return {
                ...state,
                'variaveis': state.variaveis.concat(action.data)
            }
        case MANUTENCAO_VARIAVEIS_UPD_VARIAVEL: // Usado para editar uma variavel
            return {
                ...state,
                'variaveis': state.variaveis.filter(ele=> String(ele.id_parametro) !== String(action.data.id_parametro) ).concat(action.data)
            }
        case MANUTENCAO_VARIAVEIS_UPD_VALOR_VARIAVEL: // Usado para atualizar o valor de uma variavel
            return (()=>{
                const { variaveis } = state;
                variaveis.forEach(ele=>{
                    if(String(ele.id_parametro) === String(action.data.id_parametro)){
                        ele.valor = action.data.valor;
                    }
                });
                
                return {
                    ...state,
                    variaveis: [...variaveis]
                }
            })();
        case MANUTENCAO_VARIAVEIS_DEL_VARIAVEL: // Usado para excluir a variavel
            return {
                ...state,
                'variaveis': state.variaveis.filter(ele=> String(ele.id_parametro) !== String(action.data))
            }
        case MANUTENCAO_CARGO_INIT: // Usado para obter os cargos iniciais
            return {
                ...state,
                'cargos': action.data
            }
        case MANUTENCAO_CARGO_ADD: // Usado para inserir um novo cargo
            return {
                ...state,
                'cargos': [
                    ...state.cargos,
                    action.data,
                ]
            }
        case MANUTENCAO_CARGO_UPD: // Usado para editar um cargo ja existente    
            return {
                ...state,
                'cargos': state.cargos.filter(ele=> String(ele.id_cargo) !== String(action.data.id_cargo ) ).concat(action.data)
            }
        case MANUTENCAO_CARGO_DEL: // Para excluir um cargo
            return {
                ...state,
                'cargos': state.cargos.filter(ele=> String(ele.id_cargo) !== String(action.data ) ),

            }
        default:
            return state;
    }
}
